'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _reactApollo = require('react-apollo');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createApolloClient = function createApolloClient(_ref) {
  var uri = _ref.uri,
      options = _objectWithoutProperties(_ref, ['uri']);

  var networkInterface = (0, _reactApollo.createNetworkInterface)({ uri: uri });

  networkInterface.use([{
    applyMiddleware: function applyMiddleware(request, next) {
      var authToken = localStorage.getItem('authToken');

      if (authToken) {
        request.options.headers = _extends({}, request.options.headers, {
          authorization: authToken
        });
      }

      next();
    }
  }]);

  var apolloClient = new _reactApollo.ApolloClient(_extends({
    networkInterface: networkInterface,
    dataIdFromObject: function dataIdFromObject(_ref2) {
      var __typename = _ref2.__typename,
          _id = _ref2._id;
      return __typename + _id;
    }
  }, options));

  return apolloClient;
};

exports.default = createApolloClient;